(() => {
	const CurrencyAndTaxesController = (
		$scope,
		$rootScope,
		$http,
		accountService,
		messageService,
		stringModifierService
	) => {
		$scope.$on('$viewContentLoaded', () => {
			$scope.show = false;
			$scope.isSaveSpinnningWheelActive = false;

			request.getAllCurrencies(
				$http,
				getAllCurrenciesSuccessCallback,
				getAllCurrenciesErrorCallback
			);

			request.getEditableCurrencyAndTaxes(
				$http,
				getEditableCurrencyAndTaxesSuccessCallback,
				getEditableCurrencyAndTaxesErrorCallback
			);
		});

		const request = {
			updateCurrencyAndTaxes($http, currencyAndTaxes) {
				$scope.isSaveSpinnningWheelActive = true;
				$http({
					method: 'POST',
					url: '/protected/rest/tax/update',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					transformRequest: stringModifierService.urlEncodDataTransform,
					data: {
						currency: currencyAndTaxes.currencyDTO.name,
						taxName: currencyAndTaxes.taxName,
						percentage: currencyAndTaxes.percentage
					}
				}).then(
					result => {
						taxUpdatingSuccessCallback(result.data);
						$scope.isSaveSpinnningWheelActive = false;
					},
					result => {
						$scope.isSaveSpinnningWheelActive = false;
						taxUpdatingErrorCallback(result);
					}
				);
			},
			getEditableCurrencyAndTaxes(
				$http,
				getEditableCurrencyAndTaxesSuccessCallback,
				getEditableCurrencyAndTaxesErrorCallback
			) {
				$http({
					method: 'GET',
					url: '/protected/rest/currency_and_taxes/',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(
					result => getEditableCurrencyAndTaxesSuccessCallback(result.data),
					() => getEditableCurrencyAndTaxesErrorCallback()
				);
			},
			getAllCurrencies(
				$http,
				getAllCurrenciesSuccessCallback,
				getAllCurrenciesErrorCallback
			) {
				$http({
					method: 'GET',
					url: '/public/rest/currencies',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(
					result => getAllCurrenciesSuccessCallback(result.data),
					() => getAllCurrenciesErrorCallback()
				);
			}
		};

		function getAllCurrenciesSuccessCallback(data) {
			if (data) {
				$scope.currencies = data;
			}
		}

		function getAllCurrenciesErrorCallback() {
			toastr.error('No available currencies', 'Error');
		}

		function getEditableCurrencyAndTaxesSuccessCallback(data) {
			if (data) {
				$scope.editedCurrencyAndTaxes = data;
				console.log($scope.editedCurrencyAndTaxes.isChanged);
			}
		}

		function getEditableCurrencyAndTaxesErrorCallback() {
			toastr.error('Currency&Taxes not changed', 'Error');
		}

		function taxUpdatingSuccessCallback(data) {
			if (data) {
				if (data.success) {
					accountService.getUserWeb().subscribe(data => {
						if (data.enabled) {
							$rootScope.removeBg = 'blah';
						}
					});
					messageService.showToaster('s_0', 'currencyAndTaxes');
					$scope.editedCurrencyAndTaxes.isChanged = true;
				} else {
					toastr.error(data.message, 'Error');
					$rootScope.error = true;
					$rootScope.error_message = data.message;
				}
			}
			$scope.button_disable = false;
		}

		function taxUpdatingErrorCallback(result) {
			$rootScope.authenticated = false;
			messageService.showDefaultErrorMessage(result);
			$scope.button_disable = false;
		}

		$scope.updateCurrencyAndTaxes = function() {
			$('#saveCurrencyAndTaxesModal').modal('hide');
			delete $rootScope.error;
			$scope.editedCurrencyAndTaxes.percentage = parseFloat(
				$scope.editedCurrencyAndTaxes.percentage
			);
			if (!$scope.editedCurrencyAndTaxes.taxName) {
				$scope.editedCurrencyAndTaxes.taxName = 'None';
			}
			if (!$scope.editedCurrencyAndTaxes.percentage) {
				$scope.editedCurrencyAndTaxes.percentage = 0;
			}
			if (
				$scope.editedCurrencyAndTaxes.percentage < 0 ||
				$scope.editedCurrencyAndTaxes.percentage > 100
			) {
				toastr.error(
					"Percentage cant't be less then 0 or greater then 100",
					'Error'
				);
				return;
			}

			request.updateCurrencyAndTaxes($http, $scope.editedCurrencyAndTaxes);
		};
		$scope.openModal = function() {
			if ($scope.editedCurrencyAndTaxes.isChanged) {
				$scope.updateCurrencyAndTaxes();
			} else {
				$('#saveCurrencyAndTaxesModal').modal('show');
			}
		};

		$scope.setCurrency = currency => {
			$scope.active = !$scope.active;
			$scope.editedCurrencyAndTaxes.currencyDTO = currency;
		};

		$scope.breadcrumbs = [
			{ link: '/', title: 'Dashboard' },
			{ link: '/settings', title: 'Settings' },
			{ link: null, title: 'Currency & Taxes' }
		];
	};

	angular
		.module('main')
		.controller('CurrencyAndTaxesController', CurrencyAndTaxesController);

	CurrencyAndTaxesController.$inject = [
		'$scope',
		'$rootScope',
		'$http',
		'accountService',
		'messageService',
		'stringModifierService'
	];
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/currencyAndTaxesController.js